import { areEqual } from 'common/util/perf';

export const propsAreEqual = (
  prevProps: Record<string, unknown> | undefined,
  nextProps: Record<string, unknown>,
): boolean => areEqual(prevProps, nextProps, false);
